const trelloSelector = state => state.trello;

export const getTrelloToken = store => trelloSelector().token;
